import { navigation } from './navigation';
import { earningGraphMockData } from './earningGraphMockData';
import { userInfosMockData } from './userInfosMock';
import { teamMatesMock } from './teamMatesMock';

export {
  navigation,
  earningGraphMockData,
  userInfosMockData,
  teamMatesMock
};



// WEBPACK FOOTER //
// ./src/app/models/index.js